// extracted by mini-css-extract-plugin
module.exports = {"window":"ConfirmActionModal_window__EEh5g","window__header__center":"ConfirmActionModal_window__header__center__1jRTE","window__header":"ConfirmActionModal_window__header__21kQM"};